var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"app",attrs:{"id":"app"}},[(!_vm.showNoiseTop)?_c('NoiseTop'):_vm._e(),_c('Header'),_c('main',[_c('router-view')],1),_c('Footer',{staticClass:"max-width"}),_c('CookieModal'),_c('NoiseBottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }